<template>
  <v-layout column wrap>
    <v-flex>
      <v-layout row wrap align-center>
        <v-flex>
          <span class="headline">
            Pagos
          </span>
        </v-flex>
        <v-flex md4 class="text-xs-left">
          <v-select
            :value="paymentDay"
            @change="$emit('change-payment-day', $event)"
            :items="items"
            label="Saldo"
            color="grey"
            class="w-auto"
            solo/>
        </v-flex> 
      </v-layout>
    </v-flex>
    <v-flex>
      <div v-show="checkData">
        <stacked-area @update-step="$emit('update-step')" :data="data"/>
      </div>
      <div v-show="!checkData">
        <v-layout class="align-center text-xs-center">
          <v-flex>
            <span>
              No hay información
            </span>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
  </v-layout>
</template>
<script>
import StackedArea from './StackedArea';

export default {
  props: {
    data: {
      type: Array,
      default: [],
    },
    paymentDay: {
      type: Number,
      default: 0,
    },
    internalStep: {
      type: Number,
      default: 0,
    },
  },
  components: {
    StackedArea,
  },
  data() {
    return {
      items: [
        {
          text: 'Mismo día',
          value: 0,
        },
        {
          text: 'Siguiente día',
          value: 1,
        },
        {
          text: '2 días',
          value: 2,
        },
        {
          text: '3 días',
          value: 3,
        },
        {
          text: '7 días',
          value: 7,
        },
        {
          text: '15 días',
          value: 15,
        },
        {
          text: '30 días',
          value: 30,
        },
      ],
    };
  },
  computed: {
    checkData() {
      for (let i = 0; i < this.data.length; i += 1) {
        if (
          this.data[i].totals > 0 ||
          this.data[i].reached > 0 ||
          this.data[i].contacted > 0 ||
          this.data[i].promise > 0
        ) {
          return true;
        }
      }
      return false;
    },
  },
  watch: {
    internalStep: {
      immediate: true,
      handler(value) {
        // eslint-disable-next-line
        if (value === 5 && !this.checkData) {
          this.$emit('update-step');
        }
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/panelV2/Channels/PieLine/Payments.vue